import React from "react";
import {
  Box,
  Button as MuiButton,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import type { DesignComponent } from "@/features/dmManagement/types";

interface DesignFileReplaceProps {
  components: DesignComponent[];
  replacements: Record<number, File>;
  onReplace: (designComponentId: number, file: File) => void;
  onRemoveReplace: (designComponentId: number) => void;
}

/**
 * デザインファイル差し替え
 * 注文時にデザイン構成ファイルを個別に差し替えるためのリスト表示コンポーネント
 */
export const DesignFileReplace: React.FC<DesignFileReplaceProps> = ({
  components,
  replacements,
  onReplace,
  onRemoveReplace,
}) => {
  const handleFileChange = (
    componentId: number,
    e: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const file = e.target.files?.[0];
    if (file) {
      onReplace(componentId, file);
    }
  };

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        デザインファイル差し替え（任意）
      </Typography>
      <List dense>
        {components.map((component) => {
          const replacement = replacements[component.id];
          return (
            <ListItem
              key={component.id}
              secondaryAction={
                replacement ? (
                  <IconButton
                    edge="end"
                    aria-label="取り消し"
                    onClick={() => {
                      onRemoveReplace(component.id);
                    }}
                    size="small"
                  >
                    <CloseIcon />
                  </IconButton>
                ) : null
              }
            >
              <ListItemText
                primary={component.productName}
                secondary={replacement ? `差し替え: ${replacement.name}` : null}
              />
              {!replacement && (
                <MuiButton
                  variant="outlined"
                  size="small"
                  component="label"
                  sx={{ ml: 2 }}
                >
                  差し替え
                  <input
                    type="file"
                    accept=".pdf"
                    hidden
                    onChange={(e) => {
                      handleFileChange(component.id, e);
                    }}
                    aria-label={`${component.productName} 差し替え`}
                  />
                </MuiButton>
              )}
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};
